import Vue from 'vue';
import VueRouter from 'vue-router';
import '@a/base.less';
import HTTP from '../api/http';
import dirLogger from '@d/logger-new';
import urlExt from '@w/utils/url';
import { asyncJSLoader } from '@w/utils/common';
import { zs } from '@zyb-data/stats-h5';
import { getAppInfo } from '@w/utils/system';
import { hybrid } from '@kd/hybrid';
import { Toast } from 'nut';
import { route } from '@w/utils/router';
import VueLazyload from 'vue-lazyload';
class Page {
  constructor(args) {
    this.entry = args.entry;
    this.routes = args.routes;
    this.beforeInit = args.beforeInit;
    // const BUILD_ENV = process.env.BUILD_ENV || process.env.NODE_ENV
    if (window.location.href.indexOf('www.kuaiduizuoye.com') < 0 && Number(urlExt.getQuery('debug')) === 1) {
      asyncJSLoader('https://static.kuaiduizuoye.com/product/FECommon/Js/vconsole.min.js', 'VConsole', () => {
        new VConsole(); // eslint-disable-line
        this.init();
      });
    } else {
      this.init();
    }
  }

  monitorInit() {
    // 全埋点
    zs.config({
      plat: 'kdApp',
      zpID: 'PKD-KD-C',
      env: process.env.NODE_ENV,
      logUrl:
        /www|dmis/.exec(location.href) !== null
          ? 'https://log.kuaiduizuoye.com/log/kuaidui_autotrack/h5'
          : 'https://log.kuaiduizuoye.com/log/h5_test'
    });
    this.beforeInit && typeof this.beforeInit === 'function' && this.beforeInit(Vue);
    zs.init();
  }

  async init() {
    Vue.use(HTTP);
    Vue.use(VueRouter);
    this.monitorInit();
    Vue.use(Toast);
    Vue.use(VueLazyload);
    const appInfo = await getAppInfo(hybrid);
    Vue.$cmn = Vue.prototype.$cmn = appInfo;
    Vue.route = Vue.prototype.route = route;
    const routes = this.routes || [];
    const router = new VueRouter({ routes });

    router.beforeEach((to, from, next) => {
      const title = to.meta.title || '';
      document.title = typeof title === 'function' ? title(to) : title;
      document.documentElement.setAttribute(
        'page',
        to.name || window.location.href.replace(/.+\/(\w+)\.html#(\/\w+)\?*.*/, '$1$2')
      );
      Vue.nextTick(() => {
        next();
      });
    });

    Vue.directive('log', dirLogger.loggerPV);
    Vue.directive('log-click', dirLogger.loggerClick);

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      render: h => h('div', { attrs: { id: 'app' } }, [h('router-view')])
    });
  }
}

export default Page;
